import moment from 'moment';
import { GameBuild } from '../components/App/Content/Admin/Game/gql/game-build-graphql';
import { GAME_BUILD_STATUS } from '@crazygames/game-types/src/game-build/game-build-status.type';

// do not show admins drafts (devs haven't finished the submission flow yet) and accepted (if there are accepted builds, there must be an active build)
const GAME_BUILD_STATUSES_TO_HIDE_FROM_ADMIN = ['DRAFT', 'ACCEPTED'];

export function getLatestBuild(gameBuilds: GameBuild[], status?: GAME_BUILD_STATUS) {
  return [...gameBuilds]
    .filter((build) => (status ? build.status === status : true))
    .sort((a, b) => moment(b.createdAt).diff(moment(a.createdAt)))[0];
}

export function getLatestBuildForAdmin(gameBuilds: GameBuild[]) {
  return (
    [...gameBuilds]
      .filter((build) => !GAME_BUILD_STATUSES_TO_HIDE_FROM_ADMIN.includes(build.status))
      .sort((a, b) => moment(b.createdAt).diff(moment(a.createdAt)))[0] || getLatestBuild(gameBuilds)
  );
}

export function formatSizeToMb(sizeBytes: number): string {
  const mb = sizeBytes / (1024 * 1024);
  const rounded = Math.round(mb * 1000) / 1000;
  return `${rounded} MB`;
}
